/**
 *
 *
 * @author edmsamuel
 */
import React from 'react';
import { Table, DatePicker, Divider, Input } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import numeral from 'numeral';
import View from '../../components/View';
import Cell from '../../components/Cell';
import Crud from '../../components/Crud';
import Api from '../../Api';
import Exception from '../../Exception';
class Page extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.columns = Cell.buildList([
      { title: 'PROYECTO', dataIndex: 'project.sContrato', width: '10%' },
      { title: '# REQ.', dataIndex: 'sRequisicion', width: '10%' },
      { title: '# OC / OS', dataIndex: 'sConsecutivo', width: '10%' },
      { title: 'COMPRADOR', dataIndex: 'comprador.sNombre', width: '40%' },
      { title: 'FECHA', dataIndex: 'dFecha', width: '10%' },
      { title: 'MONEDA', dataIndex: 'moneda.sNombre', width: '10%' },
      { title: 'IMPORTE', className: 'column-money', dataIndex: 'dImporte', width: '10%',
        render: val => numeral(val).format('$0,0.00')
      },
    ]);

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      busqueda: '',
      data: [],
    }

    this.load = this.load.bind(this);
    this.reload = this.reload.bind(this);
  }


  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment();
    this.load(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD'),
    );
  }

  /**
   * Cargar
   */
  async load(inicio = -1, termino = -1, busqueda = '') {
    try {
      this.setState({
        loading: true,
        query: { inicio, termino }
      });

      const filtrar = busqueda.length > 0 ? { sConsecutivo: { $like: `%${busqueda}%` } } : { dFecha: { $between: [inicio, termino] } };

      const response = await Api.query({
        model: 'ComOrden',
        attributes: [
          'iId',
          'sConsecutivo',
          'dFecha',
          'dImporte',
          'sRequisicion',
        ],
        include: [
          { as: 'comprador', attributes: ['sNombre'] },
          { as: 'project', attributes: ['sContrato'] },
          { as: 'moneda', attributes: ['sNombre'] }
        ],
        where: {
          eEstado: 'AUTORIZADA',
          iId_proveedor: Api.getProviderId(),
          ...filtrar
        },
        order: [['iId', 'DESC']]
      });

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        busqueda,
      });
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      });
      Exception.load(error).show();
    }
  }


  /**
   * Reload
   *
   */
  reload() {
    this.load(
      this.state.query.inicio,
      this.state.query.termino
    );
  }

  /**
   * Render
   *
   */
  render() {
    const crud = (
      <Crud
        collection={this.props.Collection}
        buttons={['reload']}
        onReload={this.reload}
      />
    );

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (_, fechas) =>
              this.load(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.busqueda,
              )
          } />
        <Divider type='vertical' />
        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.load(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
        <Divider type='vertical' />
        {crud}
      </div>
    );

    return (
      <View>
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1>Ordenes de compra / servicio</h1>
          <Table
            rowKey='iId'
            size='small'
            rowClassName='row-pure'
            dataSource={this.state.data}
            columns={this.columns}
            loading={this.state.loading}
            pagination={{ pageSize: 35 }}
            title={() => tableTitle}
          />
        </div>
      </View>
    )
  }
}

export default connect(
  State => ({
    Collection: State.ComOrden
  })
)(Page);

